var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.43361 0.265293C6.81678 -0.0888695 6.05827 -0.0887875 5.44152 0.265509L2.9 1.7255H2.89643L2.90893 1.73086L1.0012 2.83053C0.381722 3.18761 0 3.84824 0 4.56327V9.68114C0 10.3959 0.38141 11.0563 1.00049 11.4135L5.43799 13.9738C6.05654 14.3307 6.81846 14.3307 7.43701 13.9738L11.8745 11.4135C12.4936 11.0563 12.875 10.3959 12.875 9.68114V4.56265C12.875 3.84796 12.4936 3.18758 11.8746 2.83037L10.293 1.91773L9.25087 2.51941L9.25185 2.51998L6.76649 3.9549L4.36238 5.34291V7.06674C4.36238 7.38765 4.01504 7.58828 3.73706 7.42793C3.47888 7.279 3.3198 7.0036 3.3198 6.70555V4.74172L5.72185 3.3549L5.70935 3.34954H5.71292L8.20069 1.91323L9.24931 1.30781L7.43361 0.265293Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.dd8cd06e4c8121a82c2a86228943b25e.svg";
export { ForwardRef as ReactComponent };